import React, {useEffect, useRef, useState} from 'react';
import {api} from '@/lib/api';

export const canEditBudgetCategory = user => ['owner','coo','boutique_manager','recruiter'].includes(user?.role);
const snapshot = item => ({product_description:item.product_description || '',category:item.category || '',cost_per_unit:item.cost_per_unit ?? 0,units:item.units ?? 1,total:item.total ?? 0});

export default function BudgetItemCategoryEditor({entry,itemIndex,categories,onUpdated,onClose}) {
  const item=(entry.items?.length ? entry.items : [entry])[itemIndex];
  const [category,setCategory]=useState(item.category);
  const [saving,setSaving]=useState(false),[error,setError]=useState('');
  const lock=useRef(false),operation=useRef(null),panel=useRef(null);
  useEffect(()=>{
    const previous=document.activeElement;panel.current.querySelector('select')?.focus();
    const key=event=>{
      if(event.key==='Escape'&&!lock.current){event.preventDefault();onClose();}
      if(event.key!=='Tab')return;
      const nodes=[...panel.current.querySelectorAll('select,button')].filter(n=>!n.disabled),first=nodes[0],last=nodes[nodes.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
    };
    document.addEventListener('keydown',key);return()=>{document.removeEventListener('keydown',key);previous?.focus();};
  },[onClose]);
  async function save(event){
    event.preventDefault();if(lock.current||category===item.category)return;
    lock.current=true;setSaving(true);setError('');
    if(operation.current?.category!==category)operation.current={category,id:crypto.randomUUID()};
    try{
      const response=await api.patch(`/budget/entries/${entry.id}/items/${itemIndex}/category`,{category,expected_item:snapshot(item),operation_id:operation.current.id});
      onUpdated(response.data);onClose();
    }catch(error){setError(error?.response?.data?.detail||'Category could not be saved. Retry or cancel to keep the current category.');}
    finally{lock.current=false;setSaving(false);}
  }
  const history=(entry.category_changes||[]).filter(change=>change.item_index===itemIndex);
  return <div className="budget-category-backdrop"><section ref={panel} className="budget-category-editor" role="dialog" aria-modal="true" aria-labelledby="budget-category-title">
    <h2 id="budget-category-title">Change item category</h2><p>{item.product_description || 'Purchased item'}</p>
    <p className="budget-workspace__review-note">{entry.vendor} · {entry.date} · {item.entry_type==='summary' ? 'Summarized invoice · purchase date and merchandise amount stay the same.' : 'Purchase date, quantity and amount stay the same.'}</p>
    <form onSubmit={save}><label>Category<select aria-label="Ledger item category" value={category} disabled={saving} onChange={event=>setCategory(event.target.value)}>{categories.map(value=><option key={value}>{value}</option>)}</select></label>
      {error&&<p role="alert">{error}</p>}
      <div><button type="submit" disabled={saving||category===item.category}>{saving?'Saving…':'Save category'}</button><button type="button" disabled={saving} onClick={onClose}>Cancel</button></div>
    </form>
    {history.length>0&&<details><summary>Category history</summary>{history.map(change=><p key={change.operation_id}>{change.from} → {change.to} · {change.by_name||change.by} · {new Date(change.at).toLocaleString()}</p>)}</details>}
  </section></div>;
}
